import { Flex } from 'antd';
import { Button } from '@mui/material';

const RefreshIcon = ({ color = 'white' }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path
			d="M2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C12.0967 2.50789 14.1092 3.32602 15.6167 4.78333L17.5 6.66667"
			stroke={color}
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path d="M17.5 2.5V6.66667H13.3333" stroke={color} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
		<path
			d="M17.5 10C17.5 11.9891 16.7098 13.8968 15.3033 15.3033C13.8968 16.7098 11.9891 17.5 10 17.5C7.90329 17.4921 5.89081 16.674 4.38333 15.2167L2.5 13.3333"
			stroke={color}
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path d="M6.66667 13.3333H2.5V17.4999" stroke={color} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const FormSubmitButton = ({ activate = false, detail, formId }) => {
	const isUpdate = Boolean(detail);
	const label = isUpdate ? 'Update' : 'Submit';

	return (
		<Flex justify="flex-end" align="flex-end">
			<Button
				type="submit"
				form={formId}
				disabled={activate}
				variant="contained"
				startIcon={isUpdate ? <RefreshIcon color={activate ? '#101828' : '#FFFFFF'} /> : null}
				sx={{
					minWidth: isUpdate ? '110px' : '96px',
					height: '36px',
					px: 2,
					gap: isUpdate ? 0.75 : 0,
					borderRadius: '10px',
					fontSize: '14px',
					fontWeight: 500,
					lineHeight: '20px',
					textTransform: 'none',
					boxShadow: 'none',
					color: '#FFFFFF',
					bgcolor: '#155DFC',
					transition: 'all 0.2s ease',
					'& .MuiButton-startIcon': {
						margin: 0,
					},
					'&:hover': {
						bgcolor: activate ? '#155DFC' : '#0F4CD6',
						boxShadow: 'none',
					},
					'&.Mui-disabled': {
						color: '#101828',
						backgroundColor: '#F3F4F6',
					},
				}}
			>
				{label}
			</Button>
		</Flex>
	);
};

export default FormSubmitButton;
